export default __webpack_public_path__ + "static/media/dashboard.f2b84b53.png";